import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";

/* import RecentSales from "../Recent/RecentSales";
import CardFilter from "../CardFilter";
import ProductosTable from "./ProductosTable"; */
import { FaPlus } from "react-icons/fa6";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { MdOutlineFileDownload } from "react-icons/md";
import { es } from "date-fns/locale";

import buttonStyles from "../../../../styles/Button.module.css";
import menuStyle from "../../../../styles/Menu.module.css";
import styles from "./../tooltip.module.css";

import * as api from "helper/helper";
import "../Productos/productosTable.css";
import CreateOrden from "./CreateOrden";
import SearchBar from "../SearchBar";

//import { ImagePathBuilder, range, Singleton } from "helper/tools";
//import TableOptionCheck, { FilterType } from "./TableOptionCheck";
import "./../htmlTable.css";

import VentasTable from "./VentasTable";
import TableOptionCheck, { FilterType } from "../Productos/TableOptionCheck";
import PagedFetch, {
  buildPageButtonsInfo,
  Init,
} from "../../helperFunctions/PagedFetch";
import FilterButton from "../FilterButton/FilterButton";
import { format } from "date-fns";
import { buildName, getMonthNames2, getWeekDays } from "helper/tools";
import ExportCSV from "../ExportCSV";
import { ORDEN_VENTA_STATUS } from "../../helperFunctions/helpers";
import { CurrencyInput } from "components/CurrencyInput";
/*
function SectionOption(id = "", title = "", isSelected = false) {
  this.id = id;
  this.title = title;
  this.isSelected = isSelected;
}*/

function VentasCatalogo({ subSectionId }) {
  const createProductoRef = useRef();

  const filtrosRef = useRef([]);
  const dateRangeRef = useRef();

  //const selectedDateRange = useRef("");

  const dateRangeEleRef = useRef();
  const csvRef = useRef();

  const scrollTopRef = useRef();

  const selectedBodegaItem = useRef(null);
  const selectedEstadoOrdenItem = useRef(null);
  const selectedTipoEntregaItem = useRef(null);
  const selectedFechaOrdenItem = useRef(null);
  const selectedFechaOrdenFinItem = useRef(null);
  const selectedStatusItem = useRef(null);

  const [modalData, setModalData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [productos, setProductos] = useState([]);
  //const [tags, setTags] = useState([]);
  const [bodegaStatuses, setBodegaStatuses] = useState([]);
  const [estadosOrden, setEstadosOrden] = useState([]);
  const [tiposEntrega, setTiposEntrega] = useState([]);
  const [estatusOrden, setEstatusOrden] = useState([]);

  const [csvData, setCSVData] = useState(null);

  const Menus = {
    StatusBodega: 0,
    EstadosOrden: 1,
    TipoEntrega: 2,
    FechaOrden: 3,
    Estatus: 4,
  };

  const [filtros, setFiltros] = useState([
    { type: Menus.StatusBodega, name: "Estado Bodega" },
    { type: Menus.EstadosOrden, name: "Estado Orden" },
    {
      type: Menus.TipoEntrega,
      name: "Tipo Entrega",
    },
    {
      type: Menus.Estatus,
      name: "Estatus",
    },
    {
      type: Menus.FechaOrden,
      name: "Fecha Orden",
    },
    /* { type: "add_filter", name: "Agregar filtro" },*/
  ]);

  const handleScroll = (setIt = false) => {
    /*  if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
          setScrollPosition(window.scrollY);
          localStorage.setItem('scrollPos', window.scrollY); // Persist across reloads
        }, 100); // Debounce for 100ms
        */
    if (!setIt) {
      scrollTopRef.current = document.documentElement.scrollTop;
      return;
    }
    setTimeout(() => {
      document.documentElement.scrollTop = scrollTopRef.current;
    }, 100); // Debounce for 100ms
  };

  /** PAGING */
  const [searchCriteria, setSearchCriteria] = useState({
    sortAsc: false,
    sortBy: "id",
  });
  const [pageButtons, setPageButtons] = useState([Init.Vars.PageButtons]);

  ///start changes CLASS
  const pagingInfoRef = useRef(new PagedFetch());
  const [responsePagingInfo, setResponsePagingInfo] = useState({
    ...Init.Vars.ResponsePagingInfo,
  });

  const fetchData = async (resetPageInfo = true) => {
    let criteria = searchCriteria;
    /// reset pag info
    if (resetPageInfo) pagingInfoRef.current.resetPageInfo();

    const PageSize = 25;
    pagingInfoRef.current.updatePageSize(PageSize);
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  };

  const fetchCatalogos = async () => {
    setIsLoading(true);
    const responseEstadosBodega = await api.estadosBodega().catch((error) => {
      toast.error("Error al pedir estados bodega.");
      setIsLoading(false);
    });
    if (!responseEstadosBodega) return;

    setBodegaStatuses(responseEstadosBodega.data);

    const responseEstadosOrden = await api.estadosOrden().catch((error) => {
      toast.error("Error al pedir estadosOrden.");
      setIsLoading(false);
    });
    if (!responseEstadosOrden) return;

    setEstadosOrden(responseEstadosOrden.data);

    const responseTiposEntrega = await api.tiposEntrega().catch((error) => {
      toast.error("Error al pedir tiposEntrega.");
      setIsLoading(false);
    });
    if (!responseTiposEntrega) return;

    setTiposEntrega(responseTiposEntrega.data);

    const responseEstatusOrden = await api.estatusOrden().catch((error) => {
      toast.error("Error al pedir estatusOrden.");
      setIsLoading(false);
    });
    if (!responseEstatusOrden) return;

    setEstatusOrden(responseEstatusOrden.data);

    setFiltros([...filtros]);

    setIsLoading(false);
  };

  useEffect(() => {
    configureDatePicker();
    /// cargar todo
    //fetchData();
    fetchCatalogos();
  }, []);

  function configureDatePicker() {
    const now = new Date();
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    const daysBack7 = new Date(now);
    daysBack7.setDate(daysBack7.getDate() - 6);
    const daysBack30 = new Date(now);
    daysBack30.setDate(daysBack30.getDate() - 29);

    const thisMonthStart = new Date(now);
    thisMonthStart.setDate(1);
    const thisMonthEnd = new Date(thisMonthStart);
    thisMonthEnd.setMonth(thisMonthEnd.getMonth() + 1);
    thisMonthEnd.setDate(-1);

    const lastMonthStart = new Date(now);
    lastMonthStart.setDate(1);
    lastMonthStart.setMonth(lastMonthStart.getMonth() - 1);
    const lastMonthEnd = new Date(lastMonthStart);
    lastMonthEnd.setMonth(lastMonthEnd.getMonth() + 1);
    lastMonthEnd.setDate(-1);

    const lastYearStart = new Date(now);
    lastYearStart.setDate(1);
    lastYearStart.setMonth(0);
    lastYearStart.setFullYear(lastYearStart.getFullYear() - 1);

    const lastYearEnd = new Date(lastYearStart);
    lastYearEnd.setFullYear(lastYearStart.getFullYear() + 1);
    lastYearEnd.setDate(-1);

    // load current Day
    const startDate = new Date();
    startDate.setHours(0, 0, 0);
    handleFechaOrdenClick(null, startDate);

    const daysOfWeek = getWeekDays(es);
    const monthNames = getMonthNames2(es);

    const TODO_LABEL = "Todo";

    dateRangeRef.current = new window.daterangepicker(
      dateRangeEleRef.current,
      {
        locale: {
          customRangeLabel: "Rango Personalizado",
          cancelLabel: "Cancelar",
          applyLabel: "Aplicar",
          weekLabel: "S#",
          daysOfWeek: daysOfWeek,
          monthNames: monthNames,
        },

        showCustomRangeLabel: true,
        showWeekNumbers: true,

        startDate: startDate,

        //minDate: startDate,
        //maxYear: now.getFullYear(), // parseInt(moment().format('YYYY'),10)

        timePicker: false,
        //`Error al Actualizar Estatus de Bodega. ${e.mensaje}`
        ranges: {
          [`${TODO_LABEL}`]: [null, null],
          Hoy: [now, now],
          Ayer: [yesterday, yesterday],
          "Ultimos 7 Dias": [daysBack7, now],
          "Ultimos 30 Dias": [daysBack30, now],
          "Este mes": [thisMonthStart, thisMonthEnd],
          "Ultimo mes": [lastMonthStart, lastMonthEnd],
          "Ultimo Año": [lastYearStart, lastYearEnd],
        },
      },
      function (start, end, label) {
        if (label === TODO_LABEL) {
          updateFechaOrdenCriteria(null);

          return;
        }
        //  var years = 23; //moment().diff(start, 'years');
        //  alert("You are " + years + " years old!");
        startDate.setHours(0, 0, 0);

        handleFechaOrdenClick(null, start, end, label);
      },
    );

    //let selectedDateRange = "";
    /*  if (startDate != null || endDate != null) {
      //
      const lastMonthStart = new Date();
      lastMonthStart.setDate(1);
      lastMonthStart.setMonth(lastMonthStart.getMonth() - 1);
      const lastMonthEnd = new Date(lastMonthStart);
      lastMonthEnd.setMonth(lastMonthEnd.getMonth() + 1);
      lastMonthEnd.setDate(-1);

      //
      selectedDateRange.current =
        format(startDate, "MMM dd, yyyy") +
        " - " +
        format(endDate, "MMM dd, yyyy");
    }*/
  }

  function createProducto(event) {
    console.log(event);
    loadItem({});
  }

  function reloadOrdenes() {
    setModalData(null);
    fetchData(false);
  }

  function loadItem(item) {
    const newItem = JSON.parse(JSON.stringify(item));
    setModalData(newItem);

    createProductoRef.current.toggleModal();
  }

  /**
   * Search handler
   */
  /*  const handleOnChange = (value) => {
    console.log("-->");

    let criteria = searchCriteria;
    let tagIds = [];

    if (value != null && value.id != null) {
      tagIds = criteria["tagIds"] ?? [];
      let tagId = value.id;
      if (!tagIds.includes(tagId)) {
        tagIds.push(tagId);
      } else {
        tagIds = tagIds.filter((f) => f !== tagId);
      }
    }

    criteria["tagIds"] = tagIds;
    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();

    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  };
*/
  const onChangeSearchText = (e) => {
    console.log("text search change " + e);

    let criteria = searchCriteria;

    criteria["texto"] = e;

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();

    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  };
  /*
  const handleClick = (event, item, options) => {
    //onClick(item, options);
    console.log("Clicked!" + item + options);

    let criteria = searchCriteria;
    let marcaIds = criteria["marcaIds"] ?? [];

    let itemId = item.id;
    if (event.currentTarget.checked && !marcaIds.includes(item.id)) {
      marcaIds.push(itemId);
    } else if (!event.currentTarget.checked && marcaIds.includes(item.id)) {
      marcaIds = marcaIds.filter((f) => f !== itemId);
    }

    criteria["marcaIds"] = marcaIds;
    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();

    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  };*/

  const handleEstadoBodegaClick = (event, item, options) => {
    updateEstadoBodegaCriteria(item.id);
  };

  const updateEstadoBodegaCriteria = (value) => {
    selectedBodegaItem.current = value;

    //onClick(item, options);
    let criteria = searchCriteria;
    criteria["EstadoBodegaId"] = selectedBodegaItem.current;
    setSearchCriteria(criteria);

    /// reset pag info
    //  pagingInfoRef.current.resetPageInfo();
    //criteria = pagingInfoRef.current.buildFetch(criteria);
    /* mantener la posicions pagina
    pagingInfoRef.current.resetPageInfo();
    */
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.StatusBodega;
    });

    if (index === -1) {
      return;
    }
    var name = selectedBodegaItem.current ?? "";
    //
    const statusFilter = bodegaStatuses.filter((currItem) => {
      return selectedBodegaItem.current === currItem.id;
    });

    name = statusFilter
      .map(function (status) {
        return status.nombre;
      })
      .join(", ");

    filtrosRef.current[index].toka(name);
  };

  const handleEstadoOrdenClick = (event, item, options) => {
    updateEstadoOrdenCriteria(item.id);
  };

  const updateEstadoOrdenCriteria = (value) => {
    selectedEstadoOrdenItem.current = value;

    //onClick(item, options);
    let criteria = searchCriteria;
    criteria["EstadoOrdenId"] = selectedEstadoOrdenItem.current;
    setSearchCriteria(criteria);

    /// reset pag info
    //  pagingInfoRef.current.resetPageInfo();
    //criteria = pagingInfoRef.current.buildFetch(criteria);
    /* mantener la posicions pagina
    pagingInfoRef.current.resetPageInfo();
    */
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.EstadosOrden;
    });

    if (index === -1) {
      return;
    }
    var name = selectedEstadoOrdenItem.current ?? "";
    //
    const statusFilter = estadosOrden.filter((currItem) => {
      return selectedEstadoOrdenItem.current === currItem.id;
    });

    name = statusFilter
      .map(function (status) {
        return status.nombre;
      })
      .join(", ");

    filtrosRef.current[index].toka(name);
  };

  const updateTipoEntregaCriteria = (value) => {
    selectedTipoEntregaItem.current = value;

    //onClick(item, options);
    let criteria = searchCriteria;
    criteria["TipoEntregaId"] = selectedTipoEntregaItem.current;
    setSearchCriteria(criteria);

    /// reset pag info
    //  pagingInfoRef.current.resetPageInfo();
    //criteria = pagingInfoRef.current.buildFetch(criteria);
    /* mantener la posicions pagina
    pagingInfoRef.current.resetPageInfo();
    */
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.TipoEntrega;
    });

    if (index === -1) {
      return;
    }
    var name = selectedTipoEntregaItem.current ?? "";
    //
    const statusFilter = tiposEntrega.filter((currItem) => {
      return selectedTipoEntregaItem.current === currItem.id;
    });

    name = statusFilter
      .map(function (status) {
        return status.nombre;
      })
      .join(", ");

    filtrosRef.current[index].toka(name);
  };

  const handleTipoEntregaClick = (event, item, options) => {
    updateTipoEntregaCriteria(item.id);
  };

  const updateEstatusCriteria = (value) => {
    selectedStatusItem.current = value;

    //onClick(item, options);
    let criteria = searchCriteria;
    criteria["EstatuOrdenId"] = selectedStatusItem.current;
    setSearchCriteria(criteria);

    /// reset pag info
    //  pagingInfoRef.current.resetPageInfo();
    //criteria = pagingInfoRef.current.buildFetch(criteria);
    /* mantener la posicions pagina
    pagingInfoRef.current.resetPageInfo();
    */
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Estatus;
    });

    if (index === -1) {
      return;
    }
    var name = selectedStatusItem.current ?? "";
    //
    const statusFilter = estatusOrden.filter((currItem) => {
      return selectedStatusItem.current === currItem.id;
    });

    name = statusFilter
      .map(function (status) {
        return status.nombre;
      })
      .join(", ");

    filtrosRef.current[index].toka(name);
  };

  const handleEstatusClick = (event, item, options) => {
    updateEstatusCriteria(item.id);
  };

  function clearCallback(item) {
    filtros.forEach((value, index) => {
      if (
        value.type === Menus.StatusBodega &&
        item.type === Menus.StatusBodega
      ) {
        clearStatusBodegaFilter();
      } else if (
        value.type === Menus.EstadosOrden &&
        item.type === Menus.EstadosOrden
      ) {
        clearStatusOrdenFilter();
      } else if (
        value.type === Menus.TipoEntrega &&
        item.type === Menus.TipoEntrega
      ) {
        clearTipoEntregaFilter();
      } else if (
        value.type === Menus.FechaOrden &&
        item.type === Menus.FechaOrden
      ) {
        clearFechaOrdenFilter();
      } else if (value.type === Menus.Estatus && item.type === Menus.Estatus) {
        clearEstatusOrdenFilter();
      }
    });
  }

  const handleFechaOrdenClick = (event, start, end, label, options) => {
    updateFechaOrdenCriteria(start, end, label);
  };

  const updateFechaOrdenCriteria = (start, end, label) => {
    selectedFechaOrdenItem.current = start;
    selectedFechaOrdenFinItem.current = end;

    //onClick(item, options);
    let criteria = searchCriteria;
    criteria["FechaOrden"] = selectedFechaOrdenItem.current;
    if (end != null) {
      criteria["HastaFechaOrden"] = selectedFechaOrdenFinItem.current;
    }
    setSearchCriteria(criteria);

    /// reset pag info
    //  pagingInfoRef.current.resetPageInfo();
    //criteria = pagingInfoRef.current.buildFetch(criteria);
    /* mantener la posicions pagina
    pagingInfoRef.current.resetPageInfo();
    */
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.FechaOrden;
    });

    if (index === -1) {
      return;
    }

    let name = "";
    if (label == null) {
      if (selectedFechaOrdenItem.current != null) {
        name = format(selectedFechaOrdenItem.current, "MMM dd, yyyy");

        if (selectedFechaOrdenFinItem.current != null) {
          name +=
            " - " + format(selectedFechaOrdenFinItem.current, "MMM dd, yyyy");
        }
      }
    } else {
      name = label;
    }
    //
    /*const statusFilter = bodegaStatuses.filter((currItem) => {
      return selectedFechaOrdenItem.current === currItem.id;
    });

    name = statusFilter
      .map(function (status) {
        return status.nombre;
      })
      .join(", ");*/

    filtrosRef.current[index].toka(name);
  };

  function clearFechaOrdenFilter(s) {
    updateFechaOrdenCriteria(null);

    let one = dateRangeRef.current.container[0];
    let two = one?.getElementsByClassName("ranges")[0];
    let three = two?.querySelectorAll("[data-range-key='Todo']")[0];
    three?.click();

    //  filtrosRef.current[Menus.FechaOrden].hideMenu();
  }

  function clearEstatusOrdenFilter(s) {
    updateEstatusCriteria(null);

    //  filtrosRef.current[Menus.FechaOrden].hideMenu();
  }

  function clearStatusBodegaFilter(s) {
    updateEstadoBodegaCriteria(null);

    filtrosRef.current[Menus.StatusBodega].hideMenu();
  }

  function clearStatusOrdenFilter(s) {
    /*  selectedBodegaItem.current = null;

    setBodegaStatuses(bodegaStatuses.slice());*/

    updateEstadoOrdenCriteria(null);

    filtrosRef.current[Menus.EstadosOrden].hideMenu();
  }

  function clearTipoEntregaFilter(s) {
    updateTipoEntregaCriteria(null);

    filtrosRef.current[Menus.TipoEntrega].hideMenu();
  }

  const searchFetchData = async (criteria) => {
    //-handleScroll();
    setIsLoading(true);
    const response = await api.searchOrdenesVentas(criteria).catch((error) => {
      toast.error("Error al buscar Ordenes Ventas.");
      setIsLoading(false);
    });
    if (!response) return;

    const { totalPages, count, isFirstPage, isLastPage } = response.data;

    const { rangePage, newPageNumber } = buildPageButtonsInfo(response.data);
    pagingInfoRef.current.updatePageNumber(newPageNumber);

    setPageButtons(rangePage);

    setResponsePagingInfo({
      count,
      isFirstPage,
      isLastPage,
      pageNumber: newPageNumber,
      totalPages,
    });

    const subset = response.data.subset.map((sub) => {
      return { ...sub };
    });

    setProductos(subset);

    setIsLoading(false);
    //-handleScroll(true);
  };

  const previousPageState = responsePagingInfo.isFirstPage
    ? "disabled disable-paging-btn"
    : "";
  const nextPageState = responsePagingInfo.isLastPage
    ? "disabled disable-paging-btn"
    : "";

  function goPreviousPage() {
    let page = pagingInfoRef.current.pageNumber();
    page -= 1;
    goToPage(page);
  }

  function goNextPage() {
    let page = pagingInfoRef.current.pageNumber();
    page += 1;
    goToPage(page);
  }

  function goToPage(pageNumber) {
    let criteria = searchCriteria;
    pagingInfoRef.current.updatePageNumber(pageNumber);
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  }

  function handleSortChange({ sortBy, sortAsc }) {
    if ((sortBy?.length ?? 0) === 0) {
      return;
    }
    let criteria = searchCriteria;
    criteria["sortBy"] = sortBy;
    criteria["sortAsc"] = sortAsc === "asc";

    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();

    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  }

  //const onGenerateTicket = async (output, item) => {
  async function changeBodegaStatus(ordenId, option) {
    const toastId = toast.loading("Actualizando Estatus de Bodega...");
    let response = await api
      .updateOrdenVentaEstadoBodega(ordenId, option.id)
      .catch((e) => {
        toast.dismiss(toastId);
        if (e.esError && e.codigoError && e.mensaje) {
          toast.error(`Error al Actualizar Estatus de Bodega. ${e.mensaje}`);
          setIsLoading(false);
          return;
        }
        toast.error("Error al Actualizar Estatus.");
        setIsLoading(false);
      });

    setIsLoading(false);
    toast.dismiss(toastId);

    if (!response) return;

    toast.success("Orden de Venta creado.");
    reloadOrdenes();
  }

  async function changeEstatuOrden(ordenId, estatuId) {
    const toastId = toast.loading("Actualizando Estatus de Orden de Venta...");
    let response = await api
      .updateOrdenVentaEstatus(ordenId, estatuId)
      .catch((e) => {
        toast.dismiss(toastId);
        if (e.esError && e.codigoError && e.mensaje) {
          toast.error(
            `Error al Actualizar Estatus de Orden de Venta. ${e.mensaje}`,
          );
          setIsLoading(false);
          return;
        }
        toast.error("Error al Actualizar Estatus de Orden.");
        setIsLoading(false);
      });

    setIsLoading(false);
    toast.dismiss(toastId);

    if (!response) return;

    toast.success("Estatus Orden de Venta Actualizado.");

    if (ORDEN_VENTA_STATUS.COMPLETADO.id === estatuId) reloadOrdenes();
  }

  async function changeEstadoOrden(ordenId, estado) {
    const toastId = toast.loading("Actualizando Estado de Orden de Venta...");
    let response = await api
      .updateOrdenVentaEstado(ordenId, estado.id)
      .catch((e) => {
        toast.dismiss(toastId);
        if (e.esError && e.codigoError && e.mensaje) {
          toast.error(
            `Error al Actualizar Estado de Orden de Venta. ${e.mensaje}`,
          );
          setIsLoading(false);
          return;
        }
        toast.error("Error al Actualizar Estado de Orden.");
        setIsLoading(false);
      });

    setIsLoading(false);
    toast.dismiss(toastId);

    if (!response) return;

    toast.success("Estatus Orden de Venta Actualizado.");
    reloadOrdenes();
  }

  async function generateFile(event) {
    let criteria = searchCriteria;

    // - setIsLoading(true);

    const response = await api
      .searchOrdenesVentasCSV(criteria)
      .catch((error) => {
        toast.error("Error al buscar Ordenes Ventas.");
        setIsLoading(false);
      });
    if (!response) return;

    csvRef.current.downloadCSV(response.data, "ordenesVenta.csv");

    // - setIsLoading(false);
  }

  function generateFile2(event) {
    //TODO: generar CSV con los filtros seleccionados

    const csvString = [
      [
        "Id",
        "Cliente",
        "Asociado",
        "Fecha Orden",
        "Bodega",
        "Estado",
        "Bodega",
        "Estado",
        "Entrega",
        "Fecha Entrega",
        "Estatus",
      ], // Specify your headers here
      ...data.map((item) => {
        const id = item.id;
        const infoCliente = item.cliente ?? item.asociado;
        const ordenDate = format(item.fechaOrden, "dd/MM/yy hh:mm a");
        const fechaEntregaDate = item.fechaEntrega
          ? format(item.fechaEntrega, "dd/MM/yy hh:mm a")
          : "-";

        return [
          id,
          buildName(infoCliente, infoCliente?.id),
          buildName(item.asociado, item.asociado?.id),
          ordenDate,
          item.estadoBodega?.nombre ?? "",
          item.estadoOrden?.nombre ?? "",
          item.tipoEntrega?.nombre ?? "",
          fechaEntregaDate,
          item.estatuOrden?.nombre ?? "",
        ];
      }),
    ] // Map your data fields accordingly
      .map((row) => row.join(","))
      .join("\n");

    csvRef.current.downloadCSV(csvString, "ordenesVenta.csv");

    /*setCSVData([
      { field1: "row1-col1", field2: "row1-col2", field3: "row1-col3" },
      { field1: "row2-col1", field2: "row2-col2", field3: "row2-col3" },
      // Include additional data as needed
    ]);*/
  }

  const skeletonItemCount = pagingInfoRef.current.pagingInfoRef.pageSize;

  const data = [
    { field1: "row1-col1", field2: "row1-col2", field3: "row1-col3" },
    { field1: "row2-col1", field2: "row2-col2", field3: "row2-col3" },
    // Include additional data as needed
  ];

  return (
    <>
      <ExportCSV ref={csvRef} />

      <div className="card recent-sales ">
        <div className="separator"></div>
        <div className="">
          <div className="container">
            <div className="header">
              <SearchBar onChange={(e) => onChangeSearchText(e)} />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: "10px",
                gap: "10px",
              }}
            >
              <button
                className={`btn btn-info ${styles.tooltip}`}
                onClick={(event) => generateFile(event)}
                style={{ marginLeft: "0px" }}
                disabled={isLoading}
              >
                <div>
                  <span className={`${styles.tooltiptext}`}>Descargar CSV</span>
                  <MdOutlineFileDownload />
                </div>
              </button>
              <button className="btn btn-primary" onClick={createProducto}>
                <div className={buttonStyles.icon_button}>
                  <FaPlus />
                  Crear Orden
                </div>
              </button>
            </div>

            <div
              className="btn-group1"
              style={{ display: "flex", columnGap: "6px" }}
            >
              {filtros.map((item, index) => {
                return (
                  <>
                    <FilterButton
                      key={index}
                      ref={(el) => (filtrosRef.current[index] = el)}
                      name={item.name}
                      canClear={item.canClear}
                      clearCallback={(ble) => clearCallback(item)}
                      tap={(e, show) => {
                        console.log("---> WE");

                        if (item.type === Menus.FechaOrden) {
                          if (show) {
                            setTimeout(() => {
                              dateRangeRef.current.show();
                            }, 200);
                          } else {
                            dateRangeRef.current.hide();
                          }
                        }
                      }}
                    >
                      <ul
                        className={`dropdown-menu ${menuStyle.height_50_scroll}`}
                        aria-labelledby="dropdownMenuClickableInside"
                      >
                        {item.type === Menus.StatusBodega &&
                          bodegaStatuses.map((bodegaStat, index) => {
                            const selected =
                              selectedBodegaItem?.current === bodegaStat.id;
                            return (
                              <TableOptionCheck
                                key={index}
                                item={bodegaStat}
                                names={item.name}
                                filterType={FilterType.OptionRadio}
                                onClick={handleEstadoBodegaClick}
                                checked={selected}
                              />
                            );
                          })}
                        {item.type === Menus.EstadosOrden &&
                          estadosOrden.map((estadoOrden, index) => {
                            const selected =
                              selectedEstadoOrdenItem?.current ===
                              estadoOrden.id;
                            return (
                              <TableOptionCheck
                                key={index}
                                item={estadoOrden}
                                names={item.name}
                                filterType={FilterType.OptionRadio}
                                onClick={handleEstadoOrdenClick}
                                checked={selected}
                              />
                            );
                          })}

                        {item.type === Menus.TipoEntrega &&
                          tiposEntrega.map((tipoEntrega, index) => {
                            const selected =
                              selectedTipoEntregaItem?.current ===
                              tipoEntrega.id;
                            return (
                              <TableOptionCheck
                                key={index}
                                item={tipoEntrega}
                                names={item.name}
                                filterType={FilterType.OptionRadio}
                                onClick={handleTipoEntregaClick}
                                checked={selected}
                              />
                            );
                          })}
                        {item.type === Menus.Estatus &&
                          estatusOrden.map((estatus, index) => {
                            const selected =
                              selectedStatusItem?.current === estatus.id;
                            return (
                              <TableOptionCheck
                                key={index}
                                item={estatus}
                                names={item.name}
                                filterType={FilterType.OptionRadio}
                                onClick={handleEstatusClick}
                                checked={selected}
                              />
                            );
                          })}
                        {item.type === Menus.FechaOrden && (
                          <>
                            <div
                              ref={dateRangeEleRef}
                              type="text"
                              name="birthday"
                              value=""
                              style={{ visibility: "collapse" }}
                            />

                            {/** <div
                              id="daterange"
                              className="selectbox pull-right"
                              onClick={() => {
                                console.log("-->>ZZZ");
                                //  dateRangeRef.current.toggle();
                              }}
                              style={{ display: "none" }}
                            >
                              <FaRegCalendarAlt style={{ fontSize: "20px" }} />
                              <span>{selectedDateRange.current}</span>{" "}
                              <b className="caret"></b>
                            </div>  */}
                          </>
                        )}
                      </ul>
                    </FilterButton>
                  </>
                );
              })}
            </div>
          </div>
        </div>

        <nav
          aria-label="Page navigation example"
          style={{ marginRight: "20px" }}
        >
          <ul className="pagination justify-content-end">
            <li
              className={`page-item ${previousPageState}`}
              onClick={(event) => goPreviousPage()}
            >
              <a
                className="page-link"
                href="#"
                tabIndex="-1"
                aria-disabled={"true"}
              >
                <FaArrowLeft />
              </a>
            </li>

            {pageButtons.map((item, index) => {
              let page = pagingInfoRef.current.pageNumber();
              let disabled =
                page === item.pageNumber ? "disabled disable-paging-btn" : "";
              return (
                <li
                  key={index}
                  className={`page-item ${disabled}`}
                  onClick={(event) => goToPage(item.pageNumber)}
                >
                  <a className="page-link" href="#">
                    {item.name}
                  </a>
                </li>
              );
            })}
            <li
              className={`page-item ${nextPageState}`}
              onClick={(event) => goNextPage()}
            >
              <a className="page-link" href="#">
                <FaArrowRight />
              </a>
            </li>
          </ul>
        </nav>

        <div className="card-body">
          <VentasTable
            items={productos}
            openItem={loadItem}
            handleSortChange={handleSortChange}
            changeBodegaStatus={changeBodegaStatus}
            changeEstatuOrden={changeEstatuOrden}
            changeEstadoOrden={changeEstadoOrden}
            isLoading={isLoading}
            reloadOrdenes={reloadOrdenes}
            skeletonItemCount={skeletonItemCount}
          />
        </div>

        <CreateOrden
          ref={createProductoRef}
          item={modalData}
          reloadOrdenes={reloadOrdenes}
        />
      </div>
    </>
  );
}

export default React.memo(VentasCatalogo);
